import { useState } from 'react';
import { employeeApi } from '../../../../api/employeeApi';


/**
 * Hook to manage employee CRUD actions.
 */
export function useEmployeeActions(loadAll) {
    const [editingId, setEditingId] = useState(null);
    const [editData, setEditData] = useState({});
    const [showAddForm, setShowAddForm] = useState(false);
    const [showCategories, setShowCategories] = useState(false);
    const [attemptedSave, setAttemptedSave] = useState(false);

    const handleSave = async (emp) => {
        setAttemptedSave(true);
        
        // Validation
        if (!emp.name?.trim()) {
            return;
        }

        try {
            if (emp.isNew) {
                await employeeApi.createEmployee(emp);
            } else {
                await employeeApi.updateEmployee(emp.id, emp);
            }
            setEditingId(null);
            setShowAddForm(false);
            setAttemptedSave(false);
            await loadAll();
        } catch (err) {
            console.error('[DEBUG] Save error:', err);
            alert('Fehler beim Speichern');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Mitarbeiter wirklich löschen?')) return;
        try {
            await employeeApi.deleteEmployee(id);
            await loadAll();
        } catch (err) {
            alert('Fehler beim Löschen');
        }
    };

    const startEdit = (emp) => {
        setAttemptedSave(false);
        setEditingId(emp.id);
        setEditData({
            name: emp.name || '',
            role: emp.role || 'Monteur',
            email: emp.email || emp.user_email || '',
            phone: emp.phone || '',
            license_class: emp.license_class || '',
            license_categories: emp.license_categories || [],
            employee_category_id: emp.employee_category_id || '',
            vacation_replacement_id: emp.vacation_replacement_id || '',
            color: emp.color || null,
            emergency_contact_name: emp.emergency_contact_name || '',
            emergency_contact_phone: emp.emergency_contact_phone || '',
            id: emp.id
        });
    };

    const startAdd = () => {
        setAttemptedSave(false);
        setShowAddForm(true);
        setEditData({
            name: '',
            email: '',
            phone: '',
            license_class: '',
            license_categories: [],
            employee_category_id: '',
            vacation_replacement_id: '', 
            color: null,
            emergency_contact_name: '',
            emergency_contact_phone: '',
            isNew: true
        });
    };

    const cancelEdit = () => {
        setAttemptedSave(false);
        setEditingId(null);
        setShowAddForm(false);
    };

    return {
        editingId, setEditingId,
        editData, setEditData,
        showAddForm, setShowAddForm,
        showCategories, setShowCategories,
        attemptedSave,
        handleSave,
        handleDelete,
        startEdit,
        startAdd,
        cancelEdit
    };
}
